.root {
  font-weight: bold;
  font-size: 2.8rem;
  text-align: right;
}

.root > * {
  font-weight: bold;
  font-size: 1.4rem;
  text-align: left;
}
